<template>
  <div class="">
    <div class="d-flex flex-row align-center justify-space-between mb-4">
      <div class="top-header mb-0">Sales</div>
    </div>

    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>

    <div class="d-flex flex-row align-center justify-space-between mb-5">
      <v-btn
        v-if="hasPermissions(createBtnPerms)"
        class="text-capitalize white--text"
        width="200"
        color="#0F52BC"
        tile
        depressed
        @click="goToCreate()"
      >
        <img class="mr-1" width="28px" height="28px" src="/icons/plus.svg" />
        New Sale
      </v-btn>

      <div class="d-flex flex-row align-center">
        <v-text-field
          @keydown.enter="getSales()"
          v-model="qSearch"
          solo
          dense
          flat
          :label="$t('SearchAccounts') + '...'"
          style="max-width: 250px; border-radius: 8px"
          hide-details
        >
          <img
            slot="prepend-inner"
            width="20px"
            height="20px"
            src="/icons/search.svg"
          />
        </v-text-field>
        <v-btn
          depressed
          tile
          class="text-capitalize white--text ml-5"
          color="#0F52BC"
          @click="getSales()"
        >
          <img width="32px" height="32px" src="/icons/reload.svg" />
          {{ $t("Reload") }}</v-btn
        >
      </div>
    </div>

    <v-data-table
      :headers="headers"
      :items="sales"
      :options.sync="options"
      :server-items-length="totalSales"
      :loading="loadingTable"
      :loading-text="`${$t('Loading')}... ${$t('PleaseWait')}`"
      :footer-props="footerProps"
    >
    </v-data-table>
  </div>
</template>

<script>
import RestResourceAdmin from "@/api/apiAdminService";
import { ResponseStatus } from "@/models/ResponseStatusEnum";
import { Permission } from "@/utils/permissions";
import { permissionMixin } from "@/utils/mixins";
import { vdataTable } from "@/plugins/vuetify-custom-props";
import RestResourceSeller from "../../api/apiSellerService";
import RestResourceSales from "../../api/apiSalesService";
export default {
  name: "AdminList",
  mixins: [permissionMixin],
  data() {
    return {
      loadingTable: false,
      sales: [],
      options: {},
      footerProps: {
        ...vdataTable.footerProps,
        prevIcon: "mdi-chevron-left orange--text text--darken-2",
        nextIcon: "mdi-chevron-right orange--text text--darken-2"
      },
      totalSales: 0,
      qSearch: "",
      errorAlert: false,
      errorMsg: "",
      filterParams: {
        name: null,
        email: null,
        phone: null,
      },
      headers: [
        {
          text: "Price",
          width: 225,
          align: "start",
          sortable: false,
          value: "price"
        },
        { text: "Seller", value: "seller.email", sortable: false },
        { text: "Register date", value: "createdAt", sortable: false }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.getSales();
      },
      deep: true
    }
  },
  computed: {
    editPencilPerms() {
      return [Permission.EDIT_ADMIN];
    },
    createBtnPerms() {
      return [Permission.ADD_ADMIN];
    }
  },
  methods: {
    getSales() {
      if (this.qSearch.length >= 1 && this.qSearch.length <= 2) {
        this.errorAlert = true;
        this.errorMsg = "The search must have 3 or more characters.";
        return;
      }
      this.loadingTable = true;
      RestResourceSales.prototype
        .getSales(this.getParams())
        .then(response => {
          if (response.status === ResponseStatus.OK) {
            this.totalSales = response.data.total;
            this.sales = response.data.data;
            console.log(this.sales);
            this.sales.forEach((sales, index) => {
              this.sales[index].createdAt = this.sales[index].createdAt
                .split("T")
                .join(" ")
                .split("-")
                .join("/")
                .split(".")[0];
            });
          }
        })
        .catch(error => {
          this.errorMsg = error.response.data.message;
          this.errorAlert = true;
        })
        .finally(() => {
          this.loadingTable = false;
        });
    },
    goToCreate() {
      this.$router.push({ name: "new_sale" });
    },
    getParams() {
      const { page, itemsPerPage } = this.options;
      let params = {
        q: this.qSearch || null,
        skip: (page - 1) * itemsPerPage,
        limit: itemsPerPage
      };
      params = { ...params, ...this.filterParams };
      return params;
    }
  }
};
</script>

<style>
.admin-filter-input >>> .v-input__slot {
  min-height: 30px !important;
  height: 30px !important;
  font-size: 1rem !important;
  font-weight: 200;
}
.admin-filter-input >>> .v-select__slot .v-input__append-inner {
  margin-top: 5px !important;
}
.admin-filter-input >>> .v-select__selections {
  font-size: 12px;
}
</style>
